import { combineReducers } from 'redux'
import { combineForms } from 'react-redux-form'

import * as h2Api from '../h2Api'
import * as actions from '../actions/connectSearchActions'

const goalFields = actions.goals.reduce((map, goal) => {
  return { ...map, [`goal${goal.id}`]: false }
}, {})
const criteriaFields = actions.criteria.reduce((map, criterion) => {
  return { ...map, [`criterion${criterion.id}`]: false }
}, {})
const initialCriteriaForm = {
  zipCode: '',
  distance: '15',
  ...goalFields,
  ...criteriaFields
}
const forms = combineForms(
  {
    criteriaForm: initialCriteriaForm
  },
  'connectSearch.forms'
)

export default combineReducers({
  searchRequest: h2Api.restReducer(actions.SEARCH_PROFILES, { result: [] }),
  forms
})
